import { useSiteInfo } from '@contexts/SiteInfoContext';
import SiteMapping from '@configs/siteMapping';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import breakPoint from '../../utils/constants';
import { getUserDevice } from '../../utils/getUserDevice';
import { useWindowDimensions } from '../../hooks/windowDimension';
// 789y stands for bong88 and viva88
const CategoryBarFor789y = ({ handleSelect, isSelected }) => {
    const { t } = useTranslation();

    const categoryArr = [
        { name: 'Products', i18nKey: 'lbl_Products' },
        { name: 'Live Score', i18nKey: 'lbl_LiveScore' },
    ];
    const [categories, setCategories] = useState(categoryArr);
    const { width } = useWindowDimensions();

    useEffect(() => {
        const userDevice = getUserDevice();
        if (userDevice === 'mobile' && width < breakPoint.mediumWidth) {
            setCategories(categoryArr);
            return;
        }

        if (width > breakPoint.mediumWidth) {
            setCategories([]);
        } else {
            setCategories(categoryArr);
        }
    }, [width]);

    return (
        <div className="tabs tabs--underline">
            <div className="tabs__content">
                {categories.map((category) => (
                    <div
                        key={category.name}
                        className="tab"
                        data-selected={isSelected === category.name}
                        onClick={() => handleSelect(category.name)}
                        role={category.name === 'Products' ? 'mobile-visible' : ''}
                    >
                        <a className="btn">
                            <span className="text">{t(category.i18nKey)}</span>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

const CategoryBarForNova88 = ({ handleSelect, isSelected }) => {
    const categories = [
        { name: 'Live Score', i18nKey: 'lbl_LiveScore' },
    ];
    const { t } = useTranslation();

    return [];

    return (
        <div className="main__bar">
            {categories.map((category) => (
                <a
                    className="btn"
                    key={category.name}
                    data-selected="true" // TODO: 當 categorires 兩個以上時要新增判斷
                    onClick={() => handleSelect(category)}
                >
                    <span className="text">{t(category.i18nKey)}</span>
                </a>
            ))}
        </div>
    );
};

const CategoryBar = ({ handleSelect, isSelected }) => {
    const { siteName } = useSiteInfo();
    return (
        {
            [SiteMapping.Nova88]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.IBCBet]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.PICA88]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.id8899]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.viva88]: (
                <CategoryBarFor789y handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.bong88]: (
                <CategoryBarFor789y handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.bettha88]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.taraPlays]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.fifabet]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
            [SiteMapping.ocean99]: (
                <CategoryBarForNova88 handleSelect={handleSelect} isSelected={isSelected} />
            ),
        }[siteName]
    );
};

export default CategoryBar;
